import { createContext, useContext } from 'react';
import BackgroundMusicManager from './music-player';

export const MusicPlayerContext = createContext<BackgroundMusicManager | null>(null);

export function useMusicContext() {
    const context = useContext(MusicPlayerContext);
    if (!context) {
        throw new Error('useMusicContext must be used within a MusicPlayerProvider');
    }
    return context;
}